

































import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import Button from '@/components/Button.vue';
import ChatEmojis from '@signing-page/chat/components/ChatEmojis.vue';
import { DURATION } from '@signing-page/common/constants/tooltip';

@Component({
  components: { Icon, Button, ChatEmojis },
})
export default class ChatActions extends Vue {
  @Prop() showEmojis!: boolean;
  @Prop() isPreview: boolean;
  text: string = '';
  previewTooltipOpen: boolean = false;

  handleAddEmoji(emoji: string): void {
    this.text += emoji;
  }

  handleInput(e: any): void {
    this.$emit('input', e.target.value);
  }

  handleSend(): void {
    if (this.isPreview) {
      this.showTooltip();
      return;
    }
    this.setFocus();
    if (this.text) {
      this.$emit('send', this.text);
      this.text = '';
    }
  }

  showTooltip(): void {
    if (this.previewTooltipOpen) {
      return;
    }
    this.previewTooltipOpen = true;
    setTimeout(() => {
      this.previewTooltipOpen = false;
    }, DURATION);
  }

  setFocus() {
    const element: HTMLElement = this.$refs.input as HTMLElement;
    element.focus();
  }
}
